import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./App.css";
import Login from "./AdminDashboard/Login";
import Dashboard from "./AdminDashboard/Dashboard";
import Schools from "./AdminDashboard/Schools";
import Teachers from "./AdminDashboard/Teachers";
import TeacherParticularData from "./Component/TeacherParticularData";
import SelectSection from "./AdminDashboard/SelectSection";
import BestPerformingSchoolList from "./Component/BestPerformingSchoolList";
import ResetPassword from "./Component/ResetPassword";
import ExistingEmail from "./Component/ExistingEmail";
import DeleteTeacher from "./Component/DeleteTeacher";
import Principal from "./AdminDashboard/Principal";
import Diet from "./AdminDashboard/Diet";
import DietParticularData from "./Component/DietParticularData";
import SchoolTrainerList from "./Component/SchoolTrainerList";
import Curriculum from "./AdminDashboard/Curriculum";
import Videos from "./AdminDashboard/Videos";
import CourseList from "./Component/CourseList";
import SchoolDashboard from "./Component/SchoolDashboard";
import VideoListing from "./Component/VideoListing";
import ExportReport from "./AdminDashboard/ExportReport";
import Notifications from "./AdminDashboard/Notifications";
import SchoolBestPerformingTrainerList from "./Component/SchoolBestPerformingTrainerList";
import { ToastContainer } from "react-toastify";

function App() {
  return (
    <div className="App">
      <ToastContainer
        position="top-right"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      <BrowserRouter>
        <Routes>
          {/* Login */}
          <Route exact path="/" element={<Login />}></Route>
          <Route
            exact
            path="/select-section"
            element={<SelectSection />}
          ></Route>
          <Route
            exact
            path="/existing-email"
            element={<ExistingEmail />}
          ></Route>
          <Route
            exact
            path="/deleteProfile"
            element={<DeleteTeacher />}
          ></Route>
          <Route
            exact
            path="/reset-password/*"
            element={<ResetPassword />}
          ></Route>

          {/* Dashboard */}
          <Route exact path="/dashboard" element={<Dashboard />}></Route>
          <Route exact path="/schools" element={<Schools />}></Route>

          {/* School-Dashboard */}
          <Route
            exact
            path="/school-dashboard"
            element={<SchoolDashboard />}
          ></Route>
          <Route
            exact
            path="/schoolTrainersList"
            element={<SchoolTrainerList />}
          ></Route>
          <Route
            exact
            path="/schoolBestTrainers"
            element={<SchoolBestPerformingTrainerList />}
          ></Route>

          {/* Principal */}
          <Route exact path="/principal" element={<Principal />}></Route>
          <Route
            exact
            path="/notifications"
            element={<Notifications />}
          ></Route>
          {/* Diet */}
          <Route exact path="/diet" element={<Diet />}></Route>
          <Route
            exact
            path="/dietParticularData"
            element={<DietParticularData />}
          ></Route>

          {/* Teacher */}
          <Route exact path="/teachers" element={<Teachers />}></Route>

          <Route exact path="/curriculum" element={<Curriculum />}></Route>

          {/* Videos */}
          <Route
            exact
            path="/courses/videosList/videos"
            element={<Videos />}
          ></Route>
          <Route exact path="/courses" element={<CourseList />}></Route>
          <Route
            exact
            path="/courses/videosList"
            element={<VideoListing />}
          ></Route>

          <Route exact path="/exportReport" element={<ExportReport />}></Route>

          <Route
            exact
            path="/teacherParticularData"
            element={<TeacherParticularData />}
          ></Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
